// removed by extract-text-webpack-plugin
module.exports = {"heading":"_3lgZaCpyNvpukJMVTsxOGe","title2":"_2VZ-f4EMPMXvpO5wCr9OWk","month":"ggIUadFqVRxQybQ5RRoBQ","container":"_3vZRN_xGFpXkKcpGUXJGxA","date":"_2GymljBa_CKaQg-rXVRgBm"};


//////////////////
// WEBPACK FOOTER
// ../components/ListEvent/style.module.less
// module id = 994
// module chunks = 0